import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { map } from 'rxjs/operators';
import {
  State,
  getIsIntegrationsLoading,
  getIntegrationsAction,
  getIntegrations,
} from '../../store';

@Component({
  selector: 'integrations-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
  constructor(private readonly store: Store<State>) {}
  public isLoading$ = this.store.pipe(select(getIsIntegrationsLoading));
  public integrations$ = this.store.pipe(select(getIntegrations));

  public totalAccounts$ = this.integrations$.pipe(
    map((integrations) =>
      integrations
        .map((i) => i.installations.accounts)
        .reduce((a, b) => a + b, 0),
    ),
  );

  public totalSections$ = this.integrations$.pipe(
    map((integrations) =>
      integrations
        .map((i) => i.installations.sections)
        .reduce((a, b) => a + b, 0),
    ),
  );

  public ngOnInit() {
    this.store.dispatch(getIntegrationsAction());
  }
}
